export default __webpack_public_path__ + "static/app5-b557bb38ba01a5659867287b788b33b1.jpg";